import React from 'react';

const DeleteIcon = ({ size = 20, color='currentColor' ,...props}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17.5 4.98307C14.725 4.70807 11.9333 4.56641 9.15 4.56641C7.5 4.56641 5.85 4.64974 4.2 4.81641L2.5 4.98307" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.08203 4.14199L7.26536 3.05033C7.3987 2.25866 7.4987 1.66699 8.90703 1.66699H11.0904C12.4987 1.66699 12.607 2.29199 12.732 3.05866L12.9154 4.14199" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.7096 7.61621L15.168 16.0079C15.0763 17.3162 15.0013 18.3329 12.6763 18.3329H7.3263C5.0013 18.3329 4.9263 17.3162 4.83464 16.0079L4.29297 7.61621" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.60938 13.75H11.3844" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.91797 10.417H12.0846" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>    
  );
};

export default DeleteIcon;
